<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zUxjav/tc-custom/9780814337356.jpg?1724210130729" alt="This image is the cover for the book Foreign Words, Kritik: German Literary Theory and Cultural Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Foreign Words, Kritik: German Literary Theory and Cultural Studies
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>A new perspective on the principal developments in translation practice and theory in Germany during the Age of Goethe with emphasis on the work of Goethe, Hölderlin, and Kleist as translators.</b> </p><p>The turn of the nineteenth century was a particularly fertile period in the history of translation theory and practice. With an unprecedented number of works being carefully translated and scrutinized, this era saw a definite shift in the dominant mode of translation. Many translators began attempting, for the first time, to communicate the formal characteristics, linguistic features, and cultural contexts of the original text while minimizing the paraphrasing that distorted most eighteenth-century translations. As soon as these new rules became the norm, authorial translators—defined not by virtue of being authors in their own right but by the liberties they took in their translations—emerged to challenge them, altering translated texts in such a way as to bring them into line with the artistic and thematic concerns displayed in the translators’ own "original" work. In the process, authorial translators implicitly declared translation an art form and explicitly incorporated it into their theoretical programs for the poetic arts.</p><p>Foreign Words provides a detailed account of translation practice and theory throughout the eighteenth and early nineteenth centuries, linking the work of actual translators to the theories of translation articulated by Goethe, Wilhelm von Humboldt, and, above all, Friedrich Schleiermacher. Employing a variety of critical approaches, author Susan Bernofsky discusses in depth the work of Kleist, Hölderlin, and Goethe, whose virtuoso translations raise issues that serve to delineate a theory of translation that has relevance at the turn of the twenty-first century as well. Combining a broad historical approach with individual readings of the work of several different translators, Foreign Words paints a full picture of translation during the Age of Goethe and provides all scholars of translation theory with an important new perspective.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Bernofsky
      </h2>
      
      <p class="authorDescription body article"><p>Susan Bernofsky is assistant professor of German at Bard College.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      By Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e9c0ad1a